import { MlSpaceCardProps } from '../../molecules/ml-space-card'
import { Filter, FilterProps, FilterBuilding } from './filter'
import { AtButton, NavArrowRight } from '../../atoms'
import { AtButtonDimensions, AtButtonTypes } from '../../types'
import { NotFoundSpaces, NotFoundSpacesProps } from './not-found-spaces'
import { OrCardCarousel } from '../or-card-carousel'

export * from './configurations'
export * from './filter'
export * from './not-found-spaces'
export {
  categoryGroups,
  getCategoryGroup,
  getCategoryGroupKeyByTypes,
  getCategoryGroupByType,
  areTypesInSameGroup,
} from './category-groups'
export type { CategoryGroup } from './category-groups'

export interface OrFilterSectionProps extends Omit<FilterProps, 'withButtonSpace' | 'buildings'> {
  title: string
  results?: MlSpaceCardProps[]
  buttonLabel?: string
  buttonAction?: () => void
  notFoundBlock?: NotFoundSpacesProps
  buildings?: FilterBuilding[]
}

export const OrFilterSection = ({
  buttonAction,
  buttonLabel,
  onChange,
  results,
  spaceLabel,
  state,
  title,
  notFoundBlock,
  buildings = [],
}: OrFilterSectionProps) => (
  <section className="py-12 lg:py-20 lg:px-[10.4375rem] lg:max-w-screen-lg lg:mx-auto">
    <h2 className="px-4 lg:px-0 mb-4 lg:mb-6 font-heading font-medium text-32 leading-1.3 text-neutrals-900">
      {title}
    </h2>
    <Filter
      buildings={buildings}
      spaceLabel={spaceLabel}
      state={state}
      onChange={onChange}
      withButtonSpace
      disableBuildingFilter={true}
      disableRegionFilter={true}
    />
    {results?.length || state?.loading ? (
      <OrCardCarousel
        cards={results}
        size="small"
        buttonPositioning="right-3 -top-14"
        slideClassName="py-4 px-4 lg:first:pl-0"
        embedded
      />
    ) : (
      <NotFoundSpaces {...notFoundBlock} />
    )}
    {buttonLabel && (
      <div className="pl-4 lg:pl-0">
        <AtButton
          type={AtButtonTypes.TERTIARY}
          size={AtButtonDimensions.LARGE}
          IconRightRef={NavArrowRight}
          iconRightClasses="hidden lg:block"
          className="pl-0 lg:pl-4"
          title={buttonLabel}
          onClick={buttonAction}
        />
      </div>
    )}
  </section>
)
